










































import Vue, { PropType } from 'vue';

// Types and services
import { Candidate, WorkAuthorization } from '~/services/CandidateService';
import { User } from '~/services/IdentityService';

// Components
import ProfileTabs from './ProfileTabs.vue';
import PersonalDetails from '~/components/profile/cards/PersonalDetails.vue';
import ProfileScore from '~/components/profile/cards/ProfileScore.vue';
import { CandidateProfileScore } from '~/utils/candidate/CandidateProfileScorer';
import TermsAndConds from '~/shared/TermsAndConds.vue';

export default Vue.extend({
    name: 'Profile',
    components: {
        ProfileTabs,
        PersonalDetails,
        ProfileScore,
        TermsAndConds,
    },
    props: {
        user: {
            type: Object as PropType<User>,
            required: true,
        },
        candidate: {
            type: Object as PropType<Candidate>,
            required: true,
        },
        workAuthorizations: {
            type: Array as PropType<WorkAuthorization[]>,
            required: true,
        },
        score: {
            type: Object as PropType<CandidateProfileScore | null>,
            default: null,
        },
        disableScore: {
            type: Boolean,
            default: false,
        },
    },
});
